import React from "react";

import { useUserContext } from "../../contexts/UserContext";
import { useSnackbar } from "../../hooks/useSnackbar";
import useAuth from "../../routes/login/AuthContext";
import { DeleteSharingBadroom, PostSharingBadroom } from "../../services/RoommateApi";
import { Switch } from "../Switch";

interface IProps {
  inSameRoom: boolean;
  roommateId: string;
}

export const BadroomSwitch: React.FC<IProps> = (props) => {
  const { user, loadUser } = useUserContext();
  const { getAuthToken, isSuperAdminRead } = useAuth();
  const { showErrorSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = React.useState(false);

  const handleSave = async (_: any, checked: boolean) => {
    if (!user) return;

    setIsLoading(true);

    if (checked) {
      const res = await PostSharingBadroom(
        user.l1Id,
        user.l2Id,
        user.l3Id,
        {
          roommate: user.membershipId,
          targetRoommate: props.roommateId,
        },
        await getAuthToken()
      );

      if (!res.ok) {
        showErrorSnackbar((res?.parsedBody as any)?.error.description);
      } else {
        await loadUser();
      }
    } else {
      const deleteRes = await DeleteSharingBadroom(
        user.l1Id,
        user.l2Id,
        user.l3Id,
        {
          roommate: user.membershipId,
          targetRoommate: props.roommateId,
        },
        await getAuthToken()
      );

      if (!deleteRes.ok) {
        showErrorSnackbar((deleteRes?.parsedBody as any)?.error.description);
      } else {
        await loadUser();
      }
    }

    setIsLoading(false);
  };

  return <Switch isDisabled={isLoading || isSuperAdminRead()} switchProps={{ checked: props.inSameRoom, onChange: handleSave }} />;
};
